import { create } from 'zustand'
import type { ActiveFilters } from '@/types'

interface FilterState {
  filters: ActiveFilters
  setFilter: (type: keyof ActiveFilters, values: string[]) => void
  toggleFilter: (type: keyof ActiveFilters, value: string) => void
  clearFilters: () => void
  hasActiveFilters: () => boolean
}

const initialFilters: ActiveFilters = {
  water_tightness: [],
  fire_class: [],
  material: [],
  product: [],
}

export const useFilterStore = create<FilterState>((set, get) => ({
  filters: initialFilters,

  setFilter: (type, values) => {
    set((state) => ({
      filters: {
        ...state.filters,
        [type]: values,
      },
    }))
  },

  toggleFilter: (type, value) => {
    set((state) => {
      const currentValues = state.filters[type]
      const newValues = currentValues.includes(value)
        ? currentValues.filter((v) => v !== value)
        : [...currentValues, value]

      return {
        filters: {
          ...state.filters,
          [type]: newValues,
        },
      }
    })
  },

  clearFilters: () => set({ filters: initialFilters }),

  hasActiveFilters: () => {
    const { filters } = get()
    return Object.values(filters).some((arr) => arr.length > 0)
  },
}))
